import React from 'react';
import { Paper, Box, Typography, IconButton } from '@/ui';
import type { BudgetItem } from './types';

interface BudgetItemProps {
  item: BudgetItem;
  onEdit: () => void;
  editIcon?: React.ReactNode;
}

const BudgetItemComponent: React.FC<BudgetItemProps> = ({ item, onEdit, editIcon }) => (
  <Paper
    sx={{
      p: 2,
      backgroundColor: '#F8FAFC',
      border: '1px solid #E2E8F0',
      borderRadius: '8px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: 'none'
    }}
  >
    <Box>
      <Typography
        variant="body2"
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          color: '#475569',
          mb: 0.5
        }}
      >
        {item.label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: '18px',
            fontWeight: 700,
            color: '#1E293B'
          }}
        >
          {item.amount}
        </Typography>
        {item.frequency && item.amount !== '-' && (
          <Typography
            variant="caption"
            sx={{
              fontSize: '12px',
              color: '#64748B'
            }}
          >
            /{item.frequency}
          </Typography>
        )}
      </Box>
    </Box>
    {item.editable && (
      <IconButton
        size="small"
        onClick={onEdit}
        sx={{
          color: '#64748B',
          '&:hover': {
            backgroundColor: '#E2E8F0'
          }
        }}
      >
        {editIcon}
      </IconButton>
    )}
  </Paper>
);

export default BudgetItemComponent;


